function findPath(props) {
  const childrenProps = props.children;

  if (!childrenProps?.props) {
    return 0;
  }
  findPath(childrenProps.props);

  const childrenItems = childrenProps.props.children;
  if (Array.isArray(childrenItems)) {
    const pathVar = childrenItems.find((item) => item.type === 'path');
    return pathVar.props.d;
  }
  return childrenProps.props.d;
}

/**
 * This function will attempt to convert an svg to inconify format.
 * Currently, this only works with one path in a simple tree structure.
 * @param {*} svg SVG to convert
 * @param {*} params @height @width @color
 */
export const iconifyThisSvg = (svg, { height, width }) => {
  const IconAsReactInstance = svg();
  const pathInfo = findPath(IconAsReactInstance.props);
  const body = `<path d="${pathInfo}" fill="currentColor"/>`;
  return {
    body,
    height,
    width,
  };
};
